<script setup lang="ts">
import BasePage from '@/components/pages/BasePage/BasePage.vue';
import ChangePasswordForm from './components/ChangePasswordForm.vue';
import ChangeLanguageForm from './components/ChangeLanguageForm.vue';
import ChangeAvatarForm from './components/ChangeAvatarForm.vue';
import BasePageTitle from '@/components/pages/BasePage/BasePageTitle.vue';
import BasePageTabContent from '@/components/pages/BasePage/BasePageTabContent.vue';
import { CurrentUserProfileDto } from '@/api/generator';
import { useVeeForm } from '@/components/forms/useVeeForm';
import { useAccountStore } from '@/stores/accountStore';
import { api } from '@/api';
import { formBackendErrorHandler } from '@/errorHandling';

const accountStore = useAccountStore();
const fullName = accountStore.currentUser?.fullName;
const iuid = accountStore.currentUser?.iuid || undefined;

const {
  form,
  form: { handleSubmit },
} = useVeeForm<CurrentUserProfileDto>({
  schemaName: 'CurrentUserProfileDto',
  options: { initialValues: accountStore.profile },
  mode: 'edit',
});

const submit = handleSubmit(async (currentUserProfileDto) => {
  const { result, success } = await api.account.updateCurrentUserProfile(
    {
      currentUserProfileDto,
    },
    [formBackendErrorHandler(form)],
  );

  if (success) {
    form.resetForm({ values: result });
    if (accountStore.currentUser) {
      await accountStore.fetchAccountData(accountStore.currentUser?.id);
    }
  }
});
</script>

<template>
  <BasePage>
    <template #title>
      <BasePageTitle :title="fullName" :titleId="iuid" />
    </template>
    <BasePageTabContent>
      <template #default>
        <v-row>
          <v-col cols="4" offset="4" lg="2" offsetLg="0">
            <ChangeAvatarForm @update="submit()" />
          </v-col>
          <v-col cols="6" lg="3" offsetLg="1">
            <ChangePasswordForm />
          </v-col>
          <v-col cols="6" lg="3" offsetLg="1">
            <ChangeLanguageForm @update="submit()" />
          </v-col>
        </v-row>
      </template>
    </BasePageTabContent>
  </BasePage>
</template>
